import { Injectable } from '@angular/core';
import { NewsLetterAdapter } from './news-letter.adapter';
import { Observable } from 'rxjs';
import {
  CDCSubscriptionData,
  SubscriptionBaseData,
  SubscriptionData,
  SubscriptionLocation,
  SubscriptionSettingCollection,
  SubscriptionSettingVersion,
} from '../../model/subscription.model';

@Injectable()
export class NewsLetterConnector {
  constructor(protected adapter: NewsLetterAdapter) {}

  subscribe(data: SubscriptionData): Observable<string> {
    return this.adapter.subscribe(data);
  }

  unsubscribe(data: SubscriptionBaseData): Observable<string> {
    return this.adapter.unsubscribe(data);
  }

  getSubscription(): Observable<SubscriptionSettingCollection> {
    return this.adapter.getSubscription();
  }

  subscribeRegistrationCDC(data: CDCSubscriptionData): Observable<string> {
    return this.adapter.subscribeRegistrationCDC(data);
  }

  getSubscriptionByLocation(location: SubscriptionLocation): Observable<SubscriptionSettingVersion[]> {
    return this.adapter.getSubscriptionByLocation(location);
  }
}
